import { Users, BedDouble } from "lucide-react";
import { Section, Kpi, money } from "../dc";
import { COHORT } from "./data";

export const CohortCard = () => (
  <Section title="Multi-dog households" sub="Owners with 2+ active dogs (seen in 12 months). They almost always board together, so 2 dogs share 1 room." icon={Users} testid="cohort-multi-dog">
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))", gap: 12 }}>
      <Kpi label="Multi-dog households" value={COHORT.multi} sub={`${COHORT.multiPct}% of ${COHORT.households.toLocaleString()} active`} testid="cohort-multi-count" />
      <Kpi label="Dogs in those homes" value={COHORT.dogsInMulti} sub="≈ 2.1 dogs per home" testid="cohort-dogs" />
      <Kpi label="Boarded last year" value={COHORT.boardedLastYear} sub={`${COHORT.notBookedHoliday} not booked for the holidays`} status="warn" testid="cohort-boarded" />
      <Kpi label="Holiday revenue upside" value={money(COHORT.revenueUpside)} sub={`${COHORT.roomNightsUpside} room-nights · 2 dogs/room`} testid="cohort-upside" />
    </div>
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", marginTop: 14 }} data-testid="cohort-split">
      <BedDouble size={14} color="var(--accent-ink)" />
      <span className="label">Household size</span>
      {COHORT.split.map(([l, n]) => (
        <span key={l} className="chip"><span className="mono" style={{ fontWeight: 700 }}>{n}</span>&nbsp;{l}</span>
      ))}
      <button className="btn btn-primary btn-sm" style={{ marginLeft: "auto" }} data-testid="cohort-build-campaign">Build campaign for this cohort</button>
    </div>
  </Section>
);
